export default [
  {
    title: "Ana Sayfa",
    to: { name: "root" },
    icon: { icon: "tabler-smart-home" },
    yetki: {},
  },
  {
    title: "Kullanıcılar",
    to: { name: "kullanicilar" },
    icon: { icon: "tabler-users-group" },
    yetki: { k: [], a: true },
  },
  {
    title: "Fatura",
    to: { name: "fatura" },
    icon: { icon: "tabler-file-plus" },
    yetki: { k: [] },
  },
  {
    title: "Faturalar",
    to: { name: "faturalar" },
    icon: { icon: "tabler-credit-card-pay" },
    yetki: { k: [], a: true },
  },
  {
    title: "Fatura-Şube",
    to: { name: "faturalarsube" },
    icon: { icon: "tabler-transaction-dollar" },
    yetki: { k: [], a: true },
  },
  {
    title: "Gelir",
    to: { name: "gelir" },
    icon: { icon: "tabler-coins" },
    yetki: { k: [], a: true },
  },
  {
    title: "Gelir Gider",
    to: { name: "gelirgider" },
    icon: { icon: "tabler-coins" },
    yetki: { k: [] },
  },

  {
    title: "Şube Tanıtım",
    to: { name: "sube_tanitim" },
    icon: { icon: "fluent-mdl2--product-variant" },
    yetki: { k: [], a: true },
  },

  {
    title: "Harcama Tanıtım",
    to: { name: "harcama_tur_tanitim" },
    icon: { icon: "fluent-mdl2--product-variant" },
    yetki: { k: [], a: true },
  },
  {
    title: "Parametre",
    to: { name: "parametre" },
    icon: { icon: "tabler-settings" },
    yetki: { k: [], a: true },
  },
];
